/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {ChangeDetectorRef, Directive, Optional} from '@angular/core';
import {OompaLoompa} from '../../../utils/chocolate/oompa-loompa';
import {ExpandableRowsCount} from '../providers/global-expandable-rows';
import {DatagridWillyWonka} from './datagrid-willy-wonka';
export class ExpandableOompaLoompa extends OompaLoompa {
private expandableCount: ExpandableRowsCount;
/**
 * @param {?} cdr
 * @param {?} willyWonka
 * @param {?} expandableCount
 */
constructor(cdr: ChangeDetectorRef,  willyWonka: DatagridWillyWonka,
                expandableCount: ExpandableRowsCount) {
        if (!willyWonka) {
            throw new Error("clr-dg-row should only be used inside of a clr-datagrid");
        }
        super(cdr, willyWonka);
        this.expandableCount = expandableCount;
    }
/**
 * @return {?}
 */
get flavor() {
        return this.expandableCount.hasExpandableRow;
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: "clr-datagrid, clr-dg-row"}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ChangeDetectorRef, },
{type: DatagridWillyWonka, decorators: [{ type: Optional }, ]},
{type: ExpandableRowsCount, },
];
}

function ExpandableOompaLoompa_tsickle_Closure_declarations() {
/** @type {?} */
ExpandableOompaLoompa.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ExpandableOompaLoompa.ctorParameters;
/** @type {?} */
ExpandableOompaLoompa.prototype.expandableCount;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
